<div
  *ngIf="colVm?.columnType === Types.SectionColumnProductInfoType.Asset"
  appScaleDownText
  [scaleEnabled]="!(menu | isPrintMenu)"
  [style.color]="
    ignoreUserSetTextColorAndAutoToLightOrDarkTextColor
      ? (section | textColorBasedOnSectionHeaderBackgroundColor)
      : (menu | productMenuBasicMethod: 'getSectionHeaderTextColor' : section)
  "
  class="section-header-general section-header-asset">
  {{ menu | productMenuBasicMethod: 'getAssetColumnTitle' : colVm }}
</div>
